// prettier-ignore
/* eslint-disable require-jsdoc */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import './verificationBanner.scss';
import serverApi from '../../../utils/serverApi.js';
import validator from 'validator';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

/**
 * Verification Form
 *
 * @constructor
 */
export class VerificationBanner extends React.Component {
/**
           * @constructor
           * @param {{}} props
           * @param {{}} componentContext
          */
  constructor(props, componentContext) {
    super(props, componentContext);

    this.state = {
      value: '',
      email: '',
      error: false,
      isEmail: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
  }

  reload() {
    window.location.reload();
  }

  handleEmailSubmit(event) {
    event.preventDefault();
    this.setState({isEmail: true})
  }

  handleChange(event) {
    this.setState({ email: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const lookID = window.location.href.split('=')[1];

    /**
       * Adds a change request to the ticket.
       *
       * @param {string} dataType
       *  @param {string} value
       * @param {string} lookID
       */

    // value of field and type of field do logic
    const dataType =
      validator.isEmail(this.state.email) === true ? 'email' : 'phone';
    const value =
      dataType === 'phone' ? '+' + this.state.value : this.state.email;
    serverApi.lookVerifyById(dataType, value, lookID).then((response) => {
      if (response.data === true) {
        this.props.action();
        sessionStorage.setItem('credentials', value);
      } else {
        this.setState({ error: true })
      }
    })
  }

  render() {
    const selectedCountries = ['us', 'au', 'gb', 'ca'];
    return !this.state.error ? (
      !this.state.isEmail ? (
        <div className="verify-model">
          <form className="verification-form">
            <label>
              <h2>Please verify your phone number to continue</h2>
              <PhoneInput
                value={this.state.value}
                country={'us'}
                onChange={(value) => this.setState({ value })}
                onlyCountries={selectedCountries}
              />
            </label>
            <button
              type="button"
              className="first-button"
              onClick={this.handleSubmit}
            >
              Submit
            </button>
            <button
              type="button"
              className="third-button"
              onClick={this.handleEmailSubmit}
            >
              Use Email
            </button>
          </form>
        </div>
      ) : (
        <div className="verify-model">
          <form className="verification-form">
            <label>
              <h2>Please verify your email to continue</h2>
              <input
                type="text"
                style={{ width: '30%' }}
                value={this.state.email}
                onChange={this.handleChange}
                placeholder="Only use your email if no phone number provided"
              />
            </label>
            <button
              type="button"
              className="first-button"
              onClick={this.handleSubmit}
            >
              Submit
            </button>
            <button
              type="button"
              onClick={this.reload}
              className="second-button"
            >
              {' '}
              Try Again
            </button>
          </form>
        </div>
      )
    ) : (
      <div className="error">
        <h2>Couldn't verify. Please try again!</h2>
        <button type="button" onClick={this.reload} className="second-button">
          {' '}
          Try Again
        </button>
      </div>
    );
  }
}

VerificationBanner.propTypes = {
  onVerify: PropTypes.bool,
};

export default VerificationBanner;



// WEBPACK FOOTER //
// ./src/components/common/verificationBanner/VerificationBanner.js